
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    Button
} from '../../ui/ot'
import { CircleX, CirclePlus } from 'lucide-react';

const AdvancedSearchForm = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}

}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };

    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        formValues = form.getFieldsValue();
    }, [formReloadCount]);
    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre) => pre + 1)
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}

                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount
}) => {
    return (
        <>
            <Row>

                <Col span={24}>
                    <Form.List
                        {...field}
                        name={[field?.name ?? '', 'search']}
                        fieldKey={[field?.fieldKey ?? '', 'search']}
                    >
                        {(searchFields, { add, remove }) => {
                            return (<Row gutter={[8, 8]}>

                                {searchFields.map((searchField, fieldIndex) => <Col span={24}>
                                    <Row gutter={[8, 8]} justify="center">
                                        {!!fieldIndex && <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={24} >
                                            <Form.Item
                                                labelCol={4}
                                                wrapperCol={20}
                                                {...field}
                                                name={[field?.name ?? '', searchField?.name, 'operator']}
                                                fieldKey={[field?.fieldKey ?? searchField?.fieldKey, 'operator']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請選擇",
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    options={[
                                                        {
                                                            label: 'AND',
                                                            value: "and"
                                                        },
                                                        {
                                                            label: 'OR',
                                                            value: "or"
                                                        },
                                                    ]} />
                                            </Form.Item>
                                        </Col>}
                                        <Col xxl={!!fieldIndex ? 4 : 8} xl={!!fieldIndex ? 4 : 8} lg={!!fieldIndex ? 4 : 8} md={!!fieldIndex ? 6 : 12} sm={!!fieldIndex ? 6 : 12} xs={24}>
                                            <Form.Item
                                                labelCol={4}
                                                wrapperCol={20}
                                                {...field}
                                                name={[field?.name ?? '', searchField?.name, 'keyword']}
                                                fieldKey={[field?.fieldKey ?? searchField?.fieldKey, 'keyword']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請輸入",
                                                    },
                                                ]}
                                            >
                                                <Input
                                                   
                                                />
                                            </Form.Item>

                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={18}>
                                            <Form.Item
                                                labelCol={4}
                                                wrapperCol={20}
                                                {...field}
                                                name={[field?.name ?? '', searchField?.name, 'field']}
                                                fieldKey={[field?.fieldKey ?? searchField?.fieldKey, 'field']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請選擇",
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    options={[
                                                        {
                                                            label: '關鍵字',
                                                            value: "keyword"
                                                        },
                                                        {
                                                            label: '書名',
                                                            value: "title"
                                                        },
                                                        {
                                                            label: '作者',
                                                            value: "author"
                                                        },
                                                        {
                                                            label: 'ISBN',
                                                            value: "isbn"
                                                        },
                                                        {
                                                            label: '分類號',
                                                            value: "classification_number"
                                                        },
                                                    ]} />
                                            </Form.Item>
                                        </Col>
                                        {!fieldIndex && <Col>
                                            <Button
                                                type="text"
                                                disabled={searchFields.length >= 3}
                                                onClick={() => {
                                                    add({
                                                        operator: "and",
                                                        field: "keyword",
                                                        keyword: null
                                                    })
                                                }}>
                                                <CirclePlus />
                                            </Button>
                                        </Col>}
                                        {!!fieldIndex && <Col>
                                            <Button
                                                onClick={() => {
                                                    remove(fieldIndex)
                                                }} type="text" >
                                                <CircleX />
                                            </Button>
                                        </Col>}
                                    </Row>
                                </Col>)}
                            </Row>)
                        }}
                    </Form.List>
                </Col>
            </Row>
        </>
    );
};





export default AdvancedSearchForm;
